import React from "react";
import MenuVertical from "./Menu/MenuVertical/MenuVertical";
import "../App.scss";
import {
  useProfile,
  useAuth,
  WebsocketProvider,
  useWindowSize,
} from "../components/ui";
import { WS_URL } from "../config/url";
import MenuHorizontal from "./Menu/MenuHorizontal/MenuHorizontal";
import {Routing} from "./Routing";
import {Auth} from "./Auth/Auth";
import {Toaster} from "sonner";

export const Screen = () => {
  const { profile } = useProfile();
  const { authToken } = useAuth();
  const { windowSize } = useWindowSize();

  return (
    !!windowSize &&
    <div className={ "App " + ((windowSize.width < 1024 ||
      (windowSize.width < windowSize.height)) ? 'App_horizontal' : 'App_vertical')}>
      {!!authToken && !!profile && (
        <WebsocketProvider wsUrl={WS_URL}>
          <div className="Navigate">
            {(windowSize.width < 1024 ||
              (windowSize.width < windowSize.height)) ? <MenuHorizontal /> : <MenuVertical />}
          </div>
          <div className="Content">
            <Routing />
          </div>
          <Toaster
            expand={false}
            position="bottom-center"
            richColors
          />
        </WebsocketProvider>
      )}

      {!authToken && (
        <Auth />
      )}
    </div>
  );
};
